import type WorkHours from 'owa-service/lib/contract/WorkHours';
import type { BookingWorkHours, BookingsWorkTimeSlot } from 'owa-graph-schema';
import mapBookingsWorkTimeSlot from './mapBookingsWorkTimeSlot';
import mapWorkDay from './mapWorkDay';

const mapBookingWorkHours = (businessHours: BookingWorkHours[]): WorkHours[] => {
    const modifiedWorkHours: WorkHours[] =
        businessHours?.map(businessHour => ({
            WorkDay: mapWorkDay(businessHour.day ?? ''),
            TimeSlots: mapBookingsWorkTimeSlot(businessHour.timeSlots as BookingsWorkTimeSlot[]),
        })) ?? [];
    return modifiedWorkHours;
};

export default mapBookingWorkHours;
